// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdaptiveTooltip_placeholderTooltipContainer__diD8y {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: -1;
}

.AdaptiveTooltip_placeholderTooltipArea__8VHH\\+ {
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Tooltip/AdaptiveTooltip.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB","sourcesContent":[".placeholderTooltipContainer {\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    z-index: -1;\n}\n\n.placeholderTooltipArea {\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"placeholderTooltipContainer": `AdaptiveTooltip_placeholderTooltipContainer__diD8y`,
	"placeholderTooltipArea": `AdaptiveTooltip_placeholderTooltipArea__8VHH+`
};
export default ___CSS_LOADER_EXPORT___;
